import {gsap} from "gsap";
import {PaydayGameAssets} from "../../PaydayGameAssets";
import {Payday} from "../../Payday";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";

export const symbolLookup:{[key:string]:string} = {
    "0": "X0",
    "2": "X2",
    "4": "X4",
    "10": "X10",
    "20": "X20",
    "50": "X50",
    "100": "X100",
    "1000": "X1000",
    "10000": "MAX",
    "SC": "SC"
}

export class PaydaySymbol extends PIXI.Container {
    public winAnimation:PIXI.spine.Spine;
    public mainSprite:PIXI.Sprite;
    public spinSprite:PIXI.Sprite;
    public symbolName:string;

    constructor(size:string) {
        super();
        this.symbolName = symbolLookup[size];

        this.mainSprite = new PIXI.Sprite(Payday.assetLoader.getTextures(PaydayGameAssets.getSymbolStateTexturePath(this.symbolName))[0]);
        this.mainSprite.anchor.set(0.5,0.5);
        this.addChild(this.mainSprite);

        this.spinSprite = new PIXI.Sprite(Payday.assetLoader.getTextures(PaydayGameAssets.getSymbolStateTexturePath(this.symbolName, "_spin"))[0]);
        this.spinSprite.anchor.set(0.5,0.5);
        this.spinSprite.alpha = 0;
        this.addChild(this.spinSprite);
    }

    public getWinAnimation():gsap.core.Timeline {
        if (this.winAnimation == undefined) {
            this.winAnimation = new PIXI.spine.Spine(Payday.assetLoader.getSpineAsset(PaydayGameAssets.SYM_WIN));
            this.winAnimation.visible = false;
            this.addChildAt(this.winAnimation, 1);
        }

        const winAnimation = `${this.symbolName}_Win`;

        return gsap.timeline()
            .add(() => {
                this.winAnimation.visible = true;
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, winAnimation))
            .add(() => {
                this.winAnimation.visible = false;
            });
    }

    public setSpinning(instant:boolean = false) {
        const tl = gsap.timeline()
            .add(gsap.to(this.spinSprite, {alpha: 1, duration: 0.1}))
            .add(gsap.to(this.mainSprite, {alpha: 0, duration: 0.1}), '<')

        if (instant)
            tl.progress(1);

        return tl;
    }

    public setStill(instant:boolean = false) {
        const tl = gsap.timeline()
            .add(gsap.to(this.spinSprite, {alpha: 0, duration: 0.1}))
            .add(gsap.to(this.mainSprite, {alpha: 1, duration: 0.1}), '<')

        if (instant)
            tl.progress(1);

        return tl;
    }
}